import { useEffect, useLayoutEffect, useState } from 'react';
export const useTabsIndicatorCalculations = (wrapperRef, activeTabRef, orientation) => {
    const [indicatorPosition, setIndicatorPosition] = useState(0);
    const [indicatorSize, setIndicatorSize] = useState(0);
    const updateCalculations = () => {
        if ((activeTabRef === null || activeTabRef === void 0 ? void 0 : activeTabRef.current) && (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) {
            const activeTabBoundingRect = activeTabRef.current.getBoundingClientRect();
            const wrapperBoundingRect = wrapperRef.current.getBoundingClientRect();
            if (orientation === 'vertical') {
                setIndicatorPosition(Math.round(activeTabBoundingRect.top - wrapperBoundingRect.top) +
                    wrapperRef.current.scrollTop);
                setIndicatorSize(activeTabRef.current.offsetHeight);
            }
            else {
                setIndicatorPosition(Math.round(activeTabBoundingRect.left - wrapperBoundingRect.left) +
                    wrapperRef.current.scrollLeft);
                setIndicatorSize(activeTabRef.current.offsetWidth);
            }
        }
    };
    // TODO: extract as versatile hook shared across multiple packages
    useEffect(() => {
        const observer = new ResizeObserver(updateCalculations);
        if (activeTabRef === null || activeTabRef === void 0 ? void 0 : activeTabRef.current) {
            observer.observe(activeTabRef.current);
        }
        if (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) {
            observer.observe(wrapperRef.current);
        }
        return () => observer.disconnect();
    });
    useLayoutEffect(() => {
        updateCalculations();
    });
    return { indicatorPosition, indicatorSize };
};
//# sourceMappingURL=useTabsIndicatorCalculations.js.map